import React from 'react';
import scrollIntoView from '../utilities/scrollIntoView';

function BackToTopAnthor() {
  return (
    <div>
      <div className='back-to-top-container'>
        <div
          className='icon-back-to-top'
          onClick={() => scrollIntoView('premium-title')}
          role='presentation'
        />
      </div>
    </div>
  );
}

export default BackToTopAnthor;
